(function() {
  function initFichaTecnicaBoard(root) {
    if (!root || root.dataset.fichaTecnicaBoardInitialized === 'true') return;

    root.dataset.fichaTecnicaBoardInitialized = 'true';

    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-spec-button]'));
    var markers = Array.prototype.slice.call(root.querySelectorAll('[data-spec-marker]'));
    var activeLabel = root.querySelector('[data-active-spec-label]');
    var activeSpec = root.getAttribute('data-active-spec') || 'area';
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (!buttons.length || !markers.length) return;

    function getButtonLabel(button) {
      var label = button.querySelector('.ficha-tecnica-board__spec-kicker');
      return label ? label.textContent.trim() : '';
    }

    function setActiveSpec(specName) {
      if (!specName) return;

      activeSpec = specName;
      root.setAttribute('data-active-spec', specName);

      var activeButton = null;

      buttons.forEach(function(button) {
        var isActive = button.getAttribute('data-spec-button') === specName;

        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');

        if (isActive) {
          activeButton = button;
        }
      });

      markers.forEach(function(marker) {
        marker.classList.toggle(
          'is-active',
          marker.getAttribute('data-spec-marker') === specName
        );
      });

      if (activeLabel && activeButton) {
        activeLabel.textContent = getButtonLabel(activeButton);
      }
    }

    buttons.forEach(function(button) {
      button.addEventListener('click', function(event) {
        event.preventDefault();
        setActiveSpec(button.getAttribute('data-spec-button'));
      });

      button.addEventListener('mouseenter', function() {
        if (!canHover) return;
        setActiveSpec(button.getAttribute('data-spec-button'));
      });

      button.addEventListener('focus', function() {
        if (!canHover) return;
        setActiveSpec(button.getAttribute('data-spec-button'));
      });
    });

    setActiveSpec(activeSpec);
  }

  function initAllFichaTecnicaBoards() {
    var roots = document.querySelectorAll('.js-ficha-tecnica-board');

    roots.forEach(function(root) {
      initFichaTecnicaBoard(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFichaTecnicaBoards);
  } else {
    initAllFichaTecnicaBoards();
  }

  document.addEventListener('shopify:section:load', function(event) {
    var root = event.target.querySelector('.js-ficha-tecnica-board');

    if (root) {
      root.dataset.fichaTecnicaBoardInitialized = 'false';
      initFichaTecnicaBoard(root);
    }
  });
})();